import { Button, Chip, makeStyles, Tooltip, withStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 20,
  },
  chip: {
    fontWeight: 700,
    background: '#e3e3e3',
    '&:hover': {
        cursor: 'pointer'
    }
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const BasicPlanButton = () => {
    const classes = useStyles();
    const tooltipText = "Thanks for enrolling! At the moment, your AMS is not yet supported. We're actively working on expanding our integrations and we'll notify you as soon as it's available!"
  return (
    <div className={classes.container}>
    <LightTooltip title={tooltipText}>
        <Chip
              className={classes.chip}
              label={'AMS Support Coming Soon!'}
            />
    </LightTooltip>  
    </div>
  )
}

export default BasicPlanButton
